import { navLinks } from "@/mocks/homeData";

const hotLinks = [
  "综艺剪辑争议",
  "直播话术翻车",
  "真实营业观",
  "老字号排队疑云",
  "街拍素人走红",
  "声明时间线复盘",
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900/90 pt-14 text-foreground-50 md:pt-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* brand */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-label text-base font-black text-background-50">
                17
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold tracking-wide">17黑料</span>
                <span className="mt-1 text-[10px] tracking-[0.2em] text-foreground-50/60">
                  围观 · 热议 · 观点
                </span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-50/70">
              热门话题、网友评论、各方观点都在这里。围观群众每天都在聊什么，进来看一眼就知道，参与交流不迷路。
            </p>
            <div className="mt-5 flex gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-douban-line", "ri-tv-2-line"].map((i) => (
                <button
                  key={i}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-800 text-foreground-50/70 transition hover:bg-secondary-500 hover:text-background-50"
                  aria-label="社交图标"
                >
                  <i className={i}></i>
                </button>
              ))}
            </div>
          </div>

          {/* nav links */}
          <div className="md:col-span-3 md:col-start-6">
            <h4 className="mb-4 text-sm font-semibold tracking-wider text-foreground-50/90">站内分区</h4>
            <ul className="space-y-3 text-sm text-foreground-50/70">
              {navLinks.map((l) => (
                <li key={l.key}>
                  <a
                    href={`#${l.key}`}
                    className="inline-flex items-center gap-2 transition hover:text-accent-400"
                  >
                    <i className="ri-arrow-right-s-line text-accent-500"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="mb-4 text-sm font-semibold tracking-wider text-foreground-50/90">热门围观话题</h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-50/70">
              {hotLinks.map((h) => (
                <li key={h}>
                  <a href="#square" className="inline-flex items-center gap-2 transition hover:text-accent-400">
                    <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
                    {h}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* contact-ish */}
          <div className="md:col-span-2">
            <h4 className="mb-4 text-sm font-semibold tracking-wider text-foreground-50/90">联系茶馆</h4>
            <ul className="space-y-3 text-sm text-foreground-50/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-500"></i> hi@17hl.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-community-line text-accent-500"></i> 反馈版主
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-500"></i> 举报入口
              </li>
            </ul>
          </div>
        </div>

        {/* disclaimer */}
        <div className="mt-10 rounded-xl bg-secondary-800/70 p-4 text-xs leading-relaxed text-foreground-50/55 md:mt-12 md:p-5">
          <p className="mb-1 font-medium text-foreground-50/75">内容说明与免责声明</p>
          本站为演示型社区讨论区，页内所有话题标题、评论与观点均为虚构示例，仅用于页面效果展示，不指向任何真实人物、机构或事件。讨论内容不代表本站立场，请理性围观、勿轻信转发；如遇涉嫌侵权或不实信息，欢迎举报，我们将按规则及时处理。
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-secondary-800 py-6 text-xs text-foreground-50/55 sm:flex-row">
          <p>© 2026 17黑料 · 围观群众都在聊什么</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-verified-badge-line text-accent-500"></i>
            理性讨论 · 快乐吃瓜 · 尊重事实
          </p>
        </div>
      </div>
    </footer>
  );
}